var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#9AA3B2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_372_4544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3146 6.83609C13.2108 6.45059 12.9069 6.14664 12.5214 6.04285C11.8171 5.8501 8.99998 5.8501 8.99998 5.8501C8.99998 5.8501 6.18286 5.8501 5.47858 6.03543C5.10049 6.13922 4.78913 6.45059 4.68534 6.83609C4.5 7.54037 4.5 9.00083 4.5 9.00083C4.5 9.00083 4.5 10.4687 4.68534 11.1656C4.78913 11.5511 5.09308 11.855 5.47858 11.9588C6.19027 12.1516 8.99998 12.1516 8.99998 12.1516C8.99998 12.1516 11.8171 12.1516 12.5214 11.9662C12.9069 11.8624 13.2108 11.5585 13.3146 11.173C13.5 10.4687 13.5 9.00824 13.5 9.00824C13.5 9.00824 13.5074 7.54037 13.3146 6.83609Z",
    fill: "#071126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10297 10.3499L10.4456 9.00062L8.10297 7.65137V10.3499Z",
    fill: "#9AA3B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_372_4544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(4.5 4.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.7065b233334dbfaee9fd8e0cfebf03d8.svg";
export { ForwardRef as ReactComponent };